import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  useGetNotificationByIdQuery,
  useMarkAsReadMutation,
  useDeleteNotificationMutation,
} from "../../../store/admin/notificationSlice";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";
import { ButtonComp, CardComp } from "../../../components";
import { isSafeActionUrl } from "../../../utils/safeActionUrl";
import moment from "moment";

export default function InvestorNotificationDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isFetching, isError } = useGetNotificationByIdQuery({
    notificationId: id,
    guard: "investor",
  });
  const [markAsRead] = useMarkAsReadMutation();
  const [deleteNotification, { isLoading: isDeleting }] = useDeleteNotificationMutation();

  useEffect(() => {
    if (data?.id && !data.is_read) {
      markAsRead({ notificationId: data.id, guard: "investor" });
    }
  }, [data?.id, data?.is_read, markAsRead]);

  if (isFetching && !data) {
    return (
      <div className="p-3">
        <TableSkeletonLoader rows={4} columns={2} />
      </div>
    );
  }

  if (isError || !data) {
    return (
      <CardComp cardClassName="border-0 shadow-sm m-3">
        <p className="mb-2">We couldn’t load this notification.</p>
        <ButtonComp
          btnText="Back to notifications"
          onClick={() => navigate("/invest/notifications")}
        />
      </CardComp>
    );
  }

  const safeAction = isSafeActionUrl(data.action_url);

  return (
    <div className="p-3">
      <CardComp cardClassName="border-0 shadow-sm">
        <div className="d-flex justify-content-between gap-2 flex-wrap mb-3">
          <button
            type="button"
            className="btn btn-link text-decoration-none px-0"
            onClick={() => navigate("/invest/notifications")}
          >
            ← Back
          </button>
          <ButtonComp
            btnText={isDeleting ? "Deleting…" : "Delete"}
            variant="outline"
            fullWidth={false}
            disabled={isDeleting}
            onClick={async () => {
              await deleteNotification({ notificationId: data.id, guard: "investor" });
              navigate("/invest/notifications");
            }}
          />
        </div>
        <h4 className="fw-semibold mb-2" style={{ color: "#383838" }}>
          {data.title}
        </h4>
        <p className="text-muted small mb-3">
          {data.created_at ? moment(data.created_at).format("DD MMM YYYY, HH:mm") : ""}
          {data.type ? ` · ${data.type}` : ""}
        </p>
        <p style={{ color: "#45464e", whiteSpace: "pre-wrap" }}>{data.message}</p>
        {safeAction ? (
          <ButtonComp
            btnText="Open related page"
            className="mt-3"
            onClick={() => navigate(data.action_url)}
          />
        ) : null}
      </CardComp>
    </div>
  );
}
